<div class="h-full w-full">
    <div class="p-2 border-b border-gray-300 flex justify-between">
        <div class="primary-font font-bold text-2xl text-gray-900 flex items-center pl-2">
            {{options?.header | translate}}
        </div>
        <div>
            <button type="button" mat-icon-button (click)="closeDrawer()">
                <em class="ti ti-x text-gray-900 text-xl"></em>
            </button>
        </div>
    </div>
    <div class="rounded-md bg-blue-50 px-4 py-3" *ngIf="options?.isCustom">
        <div class="flex">
            <div class="flex-shrink-0">
            <i class="ti ti-alert-circle text-blue-700 text-2xl"></i>
            </div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
            <p class="text-base text-blue-700">{{"task.alert.applicable_only_to_job" | translate}}</p>
            </div>
        </div>
    </div>
    <div class="w-full flex flex-col service-task-form-container zuper-scrollbar">
        <form class="grid grid-cols-6 gap-3 mt-3 mx-4 mb-6" [formGroup]="taskGroup">
            <!-- Title -->
            <div class="col-span-6">
                <label for="title" class="block text-base font-medium text-gray-700">
                    {{"text.title" | translate}}
                    <span class="mandatory-field">*</span>
                </label>
                <input 
                type="text" 
                name="title" 
                formControlName="title"
                id="title" 
                class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
                placeholder="{{ 'placeholder.service_task' | translate}}"
                >       
                <p class="text-red-500 text-base mt-2" *ngIf="utilityService.getErrorMessage(taskGroup, 'title')">{{utilityService.getErrorMessage(taskGroup, 'title') | translate}}</p> 
            </div>

            <!-- Description -->
            <div class="col-span-6">
                <label for="description" class="block text-base font-medium text-gray-700">{{"description" | translate}}</label>
                <textarea 
                type="text" 
                name="description" 
                formControlName="description"
                id="description" 
                rows="10"
                class="mt-1 block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
                placeholder="{{ 'placeholder.description' | translate}}"
                ></textarea>  
            </div>

             <!-- Duration -->
             <div class="col-span-6">
                <label for="days" class="block text-base font-medium text-gray-700">
                    {{"label.estimated_duration" | translate}}
                    <span class="mandatory-field">*</span>
                </label>
                <div class="flex justify-start space-x-2 w-full">
                    <div class="flex">
                        <input 
                            type="number" 
                            name="days" 
                            formControlName="days"
                            id="days" 
                            class="mt-1 w-3/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                            placeholder="Enter Days"
                        > 
                        <span class="inline-flex items-center mt-1 px-3 text-md text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md">
                            {{'text.days' | translate}}
                        </span>
                    </div>
                    <div class="flex">
                        <input 
                            type="number" 
                            name="hours" 
                            formControlName="hours"
                            id="hours" 
                            class="mt-1 w-2/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                            placeholder="Enter Hours"
                        > 
                        <span class="inline-flex items-center mt-1 px-3 text-md text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md">
                            {{'text.hours' | translate}}
                        </span>
                    </div>

                    <div class="flex">
                        <input 
                            type="number" 
                            name="minutes" 
                            formControlName="minutes"
                            id="minutes" 
                            class="mt-1 w-2/6 block w-full rounded-l-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                            placeholder="Enter Minutes"
                        > 
                        <span class="inline-flex items-center mt-1 px-3 text-md text-gray-900 bg-gray-200 border border-l-0 border-gray-300 rounded-r-md">
                          {{'text.minutes' | translate}}
                        </span> 
                    </div>
                </div>
                <p class="text-red-500 text-base mt-2" *ngIf="getDurationError('days')">{{getDurationError('days') | translate}}</p>
                <p class="text-red-500 text-base mt-2" *ngIf="getDurationError('hours')">{{getDurationError('hours') | translate}}</p>
                <p class="text-red-500 text-base mt-2" *ngIf="getDurationError('minutes')">{{getDurationError('minutes') | translate}}</p>
                <p class="text-red-500 text-base mt-2" *ngIf="getRequiredDurationError(taskGroup, 'days') || getRequiredDurationError(taskGroup, 'hours') || getRequiredDurationError(taskGroup, 'minutes')">
                    {{getRequiredDurationError(taskGroup, 'days') ?? getRequiredDurationError(taskGroup, 'hours') ?? getRequiredDurationError(taskGroup, 'minutes')}}
                </p>

            </div>
            
            <!-- Inspection -->
            <div class="col-span-6">
                <div class="flex justify-start items-center mt-1">
                    <input id="hasInspection" formControlName="hasInspection" type="checkbox" (change)="inspectionChange()" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 cursor-pointer rounded">
                    <label for="hasInspection" class="block text-lg text-gray-700 ml-2 cursor-pointer">{{"flag.has_inspection_form" | translate}}</label>
                </div>
            </div>
            <div class="col-span-6" *ngIf="hasValidator()">
                <label for="inspection" class="block text-base font-medium text-gray-700">{{"label.inspection_form" | translate}}
                    <span class="mandatory-field" *ngIf="hasValidator()">*</span>
                </label>
                <ng-select id="inspection" ngClass="w-full" appearance="fill" [items]="listValue$ | async"
                        id="inspection" 
                        name="inspection" 
                        class="mt-1 shadow-sm"
                        bindLabel="displayValue"
                        bindValue="{{getLookupValueKey()}}"
                        placeholder="{{'placeholder.pick_inspection_form' | translate}}"
                        appendTo="body"
                        [multiple]="false"
                        [hideSelected]="true"
                        [loading]="lookupLoading"
                        typeToSearchText="{{'info.type_to_search_text' | translate}}"
                        [typeahead]="valueSubject$"
                        formControlName="inspection"
                        (change)="inspectionFormValueChange($event)"
                        (scrollToEnd)="appendValueToItems()"
                        >
                        
                        <ng-template  ng-label-tmp let-item="item" let-clear="clear">
                        <span class="ng-value-label">{{item.asset_form_name || ''}}</span>
                        <span class="ng-value-icon right" (click)="clear(item)">
                            <em class="ti ti-x close-mark cursor-pointer"></em>
                        </span>
                        </ng-template>
                        <ng-template  ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                        <span >{{item?.asset_form_name}}</span>
                        <br>
                        <span class="text-md text-secondary">{{ item?.asset_form_description}}</span>
                        </ng-template>
                </ng-select>
                <p class="text-red-500 text-base mt-2" *ngIf="utilityService.getErrorMessage(taskGroup, 'inspection')">{{utilityService.getErrorMessage(taskGroup, 'inspection') | translate}}</p>
            </div>
            <div class="col-span-6" *ngIf="options?.state === 'clone' && showCloneInspection">
                <div class="flex justify-start items-center mt-1">
                    <input id="cloneInspectionForm" formControlName="cloneInspectionForm" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 cursor-pointer rounded">
                    <label for="cloneInspectionForm" class="block text-lg text-gray-700 ml-2 cursor-pointer">{{"clone.service.task.inspection.form.answers" | translate}}</label>
                </div>
            </div>
        </form>
    </div>
    <div class="text-right border-gray-300 border-t zuper-dialog-footer pb-3">
        <button type="button" (click)="closeDrawer()" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">{{"cancel.text" | translate}}</button>
        <button type="button" (click)="submitCustom()" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary focus:outline-none">{{options?.footer?.submit | translate}}</button>
    </div>
</div>